//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import User from '@/components/User.vue';

export default {

  components: {
    User,
  },
  props: {
    data: { type: Object, default: () => ({}) },
  },

  computed: {
    ...mapGetters('currencies', ['toCurrencyFormat']),
    tradeId() {
      try {
        const { tradeId } = this.data.p2P;
        return tradeId;
      } catch (error) {
        return '';
      }
    },

    getPaymentMethodData() {
      return this.data.p2P?.paymentMethod;
    },
  },

  methods: {
    getSideColor(side) {
      return side === 1 ? 'error--text' : 'success--text';
    },
  },
};
